import {
    createContext,
    ReactNode,
    useContext,
} from 'react'

import {FieldValues, useForm, UseFormReturn} from "react-hook-form";
import {ModalWizardTabs} from "@/components/new/modalWizardTabs/ModalWizardTabs";

interface ModalWizardTabsContextProps<TDefaultValues> {
    data?: TDefaultValues
}

// Define the context type
interface ModalWizardTabsContextType<TDefaultValues> {
    data?: TDefaultValues
    useFormWizzard:  UseFormReturn<FieldValues,any,FieldValues>
}
const ModalWizardTabsContext = createContext<ModalWizardTabsContextType<any> | undefined>(undefined)

export const ModalWizardTabsProvider = <TDefaultValues,>(
    {
        data,
        children
    }: ModalWizardTabsContextProps<TDefaultValues> & { children: ReactNode }) => {
    
    const useFormWizzard = useForm()

    const contextValue: ModalWizardTabsContextType<TDefaultValues> = {
        useFormWizzard,
        data: data
    }

    return (
        <ModalWizardTabsContext.Provider value={contextValue}>
            {children}
        </ModalWizardTabsContext.Provider>
    )
}

// Custom hook to use the table context
export const useModalWizardTabsContext = <TDefaultValues,>() => {
    const context = useContext(ModalWizardTabsContext) as ModalWizardTabsContextType<TDefaultValues> | undefined;
    if (context === undefined) {
        throw new Error(
            'useTableContext must be used within a TableContextProvider'
        )
    }
    return context
}
